import ElementImageComp from './ElementImageComp.vue'
import ElementDocComp from './ElementDocComp.vue'
import ElementRedPacketComp from './ElementRedPacketComp.vue'
import ElementHousesComp from './ElementHousesComp.vue'
import ElementFloorComp from './ElementFloorComp.vue'
import ElementTabComp from './ElementTabComp.vue'
import ElementPrizeComp from './ElementPrizeComp.vue'
import ElementFilterTabComp from './ElementFilterTabComp'
import ElementVideoComp from './ElementVideoComp.vue'
import ElementTopListComp from './ElementTopListComp.vue'
import ElementCommodityComp from './ElementCommodityComp.vue'
import ElementCountDownComp from './ElementCountDownComp.vue'
import ElementHouseFilterComp from './ElementHouseFilterComp.vue'
import ElementLandlordStoryComp from './ElementLandlordStoryComp.vue'

export default {
  ElementImageComp,
  ElementPrizeComp,
  ElementRedPacketComp,
  ElementHousesComp,
  ElementFloorComp,
  ElementDocComp,
  ElementTabComp,
  ElementFilterTabComp,
  ElementVideoComp,
  ElementTopListComp,
  ElementCommodityComp,
  ElementCountDownComp,
  ElementHouseFilterComp,
  ElementLandlordStoryComp
}
